<template>
  <div>
    <content-header title="Team Details" :sub-title="subTitle" class="mb-0 mt--10"/>
    <el-form ref="form" :model="registration" :rules="rules" label-position="top" v-if="isLoaded">
      <h3>Team Details</h3>
      <el-row :gutter="60">
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Team Age Range</el-input-title>
          <el-form-item prop="product">
            <el-select class="w-100 mt-05" v-model="registration.product" value-key="_id" placeholder="Select" :disabled="hasTeamSelected">
              <el-option
                v-for="(item, i) in products"
                :key="i"
                :label="item | productFilter"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Team Name</el-input-title>
          <el-form-item prop="team.name">
            <el-input :disabled="hasTeamSelected" class="mt-05" v-model="registration.team.name" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <div v-if="national !== 4">
          <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Contact Full Name</el-input-title>
          <el-form-item prop="team.contact.name">
            <el-input :disabled="hasTeamSelected" class="mt-05" v-model="registration.team.contact.name" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Contact Mobile</el-input-title>
          <el-form-item prop="team.contact.number">
            <vue-tel-input
            :disabled="hasTeamSelected"
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="registration.team.contact.number">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Contact Email</el-input-title>
          <el-form-item prop="team.contact.email">
            <el-input :disabled="hasTeamSelected" class="mt-05" v-model="registration.team.contact.email" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title class="mb-05">Registration Confirmation Email?</el-input-title>
          <el-form-item >
            <el-checkbox border v-model="registration.sendConfirmationEmail" size="medium">
              Yes
            </el-checkbox>
          </el-form-item>
        </el-col>
        </div>

        <!-- Unisyd special field -->
        <div v-if="national === 4">
          <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Captain Name</el-input-title>
          <el-form-item prop="team.meta.captain.name">
            <el-input class="mt-05" v-model="registration.team.meta.captain.name" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Captain Mobile</el-input-title>
          <el-form-item prop="team.meta.captain.mobile">
            <vue-tel-input
            :disabled="hasTeamSelected"
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="registration.team.meta.captain.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Captain Email</el-input-title>
          <el-form-item prop="team.meta.captain.email">
            <el-input :disabled="hasTeamSelected" class="mt-05" v-model="registration.team.meta.captain.email" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
          <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Vice Captain Name</el-input-title>
          <el-form-item prop="team.meta.viceCaptain.name">
            <el-input :disabled="hasTeamSelected" class="mt-05" v-model="registration.team.meta.viceCaptain.name" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Vice Captain Mobile</el-input-title>
          <el-form-item prop="team.meta.viceCaptain.mobile">
            <vue-tel-input
            :disabled="hasTeamSelected"
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="registration.team.meta.viceCaptain.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title >Vice Captain Email</el-input-title>
          <el-form-item prop="team.meta.viceCaptain.email">
            <el-input class="mt-05" v-model="registration.team.meta.viceCaptain.email" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        </div>
      </el-row>
      <el-form-item v-if="isTCRequired">
        <el-checkbox v-model="isTCAccepted" size="medium" class="mt-10">I agree to the <a href="javascript: void(0);" @click="dialogVisible = true">Terms and Conditions</a></el-checkbox>
      </el-form-item>
    </el-form>
    <el-dialog
      :visible.sync="dialogVisible"
      :fullscreen="true"
      v-if="isTCRequired"
      >
      <div style="width:100%;height:100%">
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
        ></pdf>

      </div>
      </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  errormsg,
  // genders
} from '@/utils/constants';
import { VueTelInput } from 'vue-tel-input';
import { checkEmail, parseBirthdate } from '@/utils/form-helpers';
import pdf from 'vue-pdf';
import {
// calculateMemberAge
} from '@/utils/helpers';

const { parsePhoneNumberFromString } = require('libphonenumber-js/max');

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };
const validateEmail = {
  required: false,
  trigger: 'blur',
  validator: (rule, value, callback) => {
    if (!value) return callback();
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value && re.test(String(value).toLowerCase())) return callback();
    return callback(new Error('Invalid email address'));
  }
};
// const validateMobile = {
//   required: false,
//   trigger: 'blur',
//   validator: (rule, value, callback) => {
//     if (!value) return callback();
//     // eslint-disable-next-line no-param-reassign
//     value = value.replace(/\s/g, '');
//     const phoneNumber = parsePhoneNumberFromString(value, 'AU');
//     const phoneNumber = parsePhoneNumberFromString(value, this.countryCode);
//     const test = !!(((phoneNumber && phoneNumber.isValid() && phoneNumber.getType() === 'MOBILE')));
//     if (test) return callback();
//     return callback(new Error('Invalid mobile'));
//   }
// };

export default {
  name: 'TeamDetails',
  props: {
    value: Object,
    event: Object,
    member: Object,
  },
  components: {
    pdf,
    VueTelInput
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Mobile is required'));
      }
      // join value remomve all space
      // eslint-disable-next-line no-param-reassign
      value = value.replace(/\s/g, '');
      const phoneNumber = parsePhoneNumberFromString(value, this.countryCode);
      const test = !!(((phoneNumber && phoneNumber.isValid() && (phoneNumber.getType() === 'MOBILE' || phoneNumber.getType() === 'FIXED_LINE_OR_MOBILE'))));
      if (test) return callback();
      return callback(new Error('Invalid mobile'));
    };
    return {
      openFlagDropdown: false,
      countryDialCode: this.getCountryDialCode(),
      countryCode: this.getCountryCode(),
      isLoaded: false,
      subTitle: 'Please complete all Team Details requested below',
      registration: {},
      products: _.sortBy(this.event.products, ['ageFrom']),
      additionalQs: this.event.additionalQs,
      saleableItems: this.event.saleableItems,
      discounts: this.event.discounts,
      isTCAccepted: false,
      isTCRequired: false,
      dialogVisible: false,
      rules: {
        product: defaultRequiredRule,
        'team.name': defaultRequiredRule,
        'team.contact.name': defaultRequiredRule,
        'team.contact.number': { validator: validateMobile, trigger: 'blur' },
        'team.contact.email': { validator: checkEmail, trigger: 'blur' },
        'team.meta.captain.mobile': { validator: validateMobile, trigger: 'blur' },
        'team.meta.captain.email': validateEmail,
        'team.meta.viceCaptain.mobile': { validator: validateMobile, trigger: 'blur' },
        'team.meta.viceCaptain.email': validateEmail,
      },
      numPages: undefined,
      hasTeamSelected: false,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);

    this.$store.commit('loading', { loading: true, text: 'Loading...' });
    this.isTCRequired = this.event && this.event.products && this.event.products[0].isTCRequired ? this.event.products[0].isTCRequired : false;
    if (_.get(this, 'event.isTCRequired')) {
      this.isTCRequired = _.get(this, 'event.isTCRequired');
      try {
        const resEvent = await this.$http.get(`/assemble/api/v1/portal/files/entity/${this.event._id}/signed`);
        if (resEvent && resEvent.data) {
          const url = resEvent.data.url.toString();
          try {
            this.src = pdf.createLoadingTask(url);
            const data = await pdf.createLoadingTask(url).promise;
            this.numPages = data._pdfInfo.numPages;
            this.isTCAccepted = this.event.products[0].isTCPrefilled;
          } catch (error) {
            this.isTCRequired = false;
            this.$emit('tc-update', false);
          }
          this.$store.commit('loading', false);
        }
      } catch (error) {
        this.isTCRequired = false;
        this.$emit('tc-update', false);
        this.$store.commit('loading', false);
      }
    } else {
      this.isTCRequired = this.event && this.event.products && this.event.products[0].isTCRequired ? this.event.products[0].isTCRequired : false;
      if (this.isTCRequired) {
        try {
          const resEvent = await this.$http.get(`/assemble/api/v1/portal/files/entity/${this.event._id}/product/${this.event.products[0]._id}/signed`);
          if (resEvent && resEvent.data) {
            const url = resEvent.data.url.toString();
            try {
              this.src = pdf.createLoadingTask(url);
              const data = await pdf.createLoadingTask(url).promise;
              this.numPages = data._pdfInfo.numPages;
              this.isTCAccepted = this.event.products[0].isTCPrefilled;
            } catch (error) {
              this.isTCRequired = false;
              this.$emit('tc-update', false);
            }
            this.$store.commit('loading', false);
          }
        } catch (error) {
          this.isTCRequired = false;
          this.$emit('tc-update', false);
          this.$store.commit('loading', false);
        }
      } else {
        this.$emit('tc-update', false);
      }
    }
    console.log('value at team details', this.value);
    const profile = _.get(this, 'member.profile');
    if (this.value.team === undefined) {
      const {
        _id,
        name,
        productType,
        tags,
        team,
        additionalQs,
        saleableItems,
        discounts,
        startDate,
        endDate,
      } = this.event;

      if (team) this.hasTeamSelected = true;

      this.registration = {
        existingTeam: this.hasTeamSelected,
        eventId: _id,
        memberId: this.event.memberId,
        name,
        productType,
        tags,
        profile,
        team: team || {
          name: undefined,
          contact: {
            name: undefined,
            number: undefined,
            email: undefined,
          },
          meta: {
            captain: {
              name: undefined,
              mobile: undefined,
              email: undefined,
            },
            viceCaptain: {
              name: undefined,
              mobile: undefined,
              email: undefined,
            },
          },
        },
        product: this.event.products[0],
        additionalQs,
        saleableItems,
        discounts,
        startDate,
        endDate,
        sendConfirmationEmail: false,
      };
      this.$emit('update-step', this.registration, 0);
    } else {
      this.registration = { ...this.value, profile };
    }

    this.isLoaded = true;
    this.$store.commit('loading', false);
  },
  methods: {
    getCountryDialCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return '64'; // New Zealand
        case 21:
          return '65'; // Singapore
        default:
          return '61'; // Australia (default)
      }
    },
    getCountryCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return 'NZ'; // New Zealand
        case 21:
          return 'SG'; // Singapore
        default:
          return 'AU'; // Australia (default)
      }
    },
    handleCountryChanged(countryCode) {
      this.countryDialCode = countryCode.dialCode;
      this.countryCode = countryCode.iso2.toUpperCase();
    },
    refactorMobile(mobileNumber) {
      let mobile = _.cloneDeep(mobileNumber).replace(/\s/g, '');
      if (mobile.charAt(0) === '0') {
        mobile = mobile.substring(1);
        return `+${ this.countryDialCode }${mobile}`;
      } if (mobile.charAt(0) === '+') {
        return mobile;
      }
      if (!mobile.length) {
        return undefined;
      }
      return `+${ this.countryDialCode }${mobile}`;
    },
    updateStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (_.get(this.registration, 'team.contact.number')) {
            this.registration.team.contact.number = this.refactorMobile(this.registration.team.contact.number);
          }
          if (_.get(this.registration, 'team.meta.captain.mobile')) {
            this.registration.team.meta.captain.mobile = this.refactorMobile(this.registration.team.meta.captain.mobile);
          }
          if (_.get(this.registration, 'team.meta.viceCaptain.mobile')) {
            this.registration.team.meta.viceCaptain.mobile = this.refactorMobile(this.registration.team.meta.viceCaptain.mobile);
          }
          if (this.isTCRequired && !this.isTCAccepted) return this.$message.error('Please accept terms and conditions');

          const { ageFrom, ageTo } = this.registration.product;
          this.registration.additionalQs = _.filter(this.additionalQs, (v) => _.includes(v.productTypes, 'team') && !(v.ageFrom > ageTo || v.ageTo < ageFrom));
          this.registration.saleableItems = _.filter(this.saleableItems, (v) => _.includes(v.productTypes, 'team') && !(v.ageFrom > ageTo || v.ageTo < ageFrom));
          this.registration.discounts = _.filter(this.discounts, (v) => v.productType === 'team' && (v.from <= +this.moment() && +this.moment() <= v.to) && !(v.ageFrom > ageTo || v.ageTo < ageFrom));
          this.registration.meta = undefined;
          this.$emit('update-step', this.registration);
          return true;
        }
        return false;
      });
    },
  },
  filters: {
    formatDob(val) {
      return parseBirthdate(val, true);
    },
    productFilter(val) {
      return `Age(${val.ageFrom} - ${val.ageTo}) - $${(val.price / 100).toFixed(2)}`;
    }
  },
  computed: {
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
  },
  watch: {
    isTCAccepted(val) {
      this.$emit('tc-update', !val);
    }
  }
};
</script>

<style scoped lang="scss">
.manualAddressBtn {
  &:hover {
    color: $highlight !important;
  }
}

::v-deep .el-dialog {
  max-width: 900px !important;
}
</style>
